import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface NomaMarkProps {
    className?: string
}

/* The Noma mark: a solid N cut on a single diagonal, sized to sit on the
   cap-height of the wordmark next to it. */
export const NomaMark: FC<NomaMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 17 17'
            className={cn('size-4 shrink-0', className)}
            fill='none'
            aria-hidden='true'
            focusable='false'
        >
            <path
                d='M0 17V0h4.4l8.2 9.9V0H17v17h-4.4L4.4 7.1V17H0Z'
                fill='currentColor'
            />
        </svg>
    )
}
